import { render, staticRenderFns } from "./OnValidation.vue?vue&type=template&id=6b02a1a6&"
import script from "./OnValidation.vue?vue&type=script&lang=js&"
export * from "./OnValidation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports